import { GlIcon, GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '@gitlab/ui';
import { mapState, mapActions } from 'pinia';
import { getLocationHash, doesHashExistInUrl } from '~/lib/utils/url_utility';
import { __ } from '~/locale';
import Tracking from '~/tracking';
import LocalStorageSync from '~/vue_shared/components/local_storage_sync.vue';
import { useNotes } from '~/notes/store/legacy_notes';
import { DISCUSSION_FILTERS_DEFAULT_VALUE, HISTORY_ONLY_FILTER_VALUE, COMMENTS_ONLY_FILTER_VALUE, DISCUSSION_TAB_LABEL, DISCUSSION_FILTER_TYPES, NOTE_UNDERSCORE, ASC, DESC } from '../constants';
import notesEventHub from '../event_hub';
const SORT_OPTIONS = [
    {
        key: DESC,
        text: __('Newest first'),
        cls: 'js-newest-first'
    },
    {
        key: ASC,
        text: __('Oldest first'),
        cls: 'js-oldest-first'
    }
];
export default {
    name: 'DiscussionFilter',
    SORT_OPTIONS,
    components: {
        GlIcon,
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        LocalStorageSync
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        filters: {
            type: Array,
            required: true
        },
        selectedValue: {
            type: Number,
            default: DISCUSSION_FILTERS_DEFAULT_VALUE,
            required: false
        }
    },
    data () {
        return {
            currentValue: doesHashExistInUrl(NOTE_UNDERSCORE) ? DISCUSSION_FILTERS_DEFAULT_VALUE : this.selectedValue,
            defaultValue: DISCUSSION_FILTERS_DEFAULT_VALUE,
            displayFilters: true
        };
    },
    computed: {
        ...mapState(useNotes, [
            'getNotesDataByProp',
            'timelineEnabled',
            'isLoading',
            'sortDirection',
            'persistSortOrder',
            'noteableType'
        ]),
        sortStorageKey () {
            return `sort_direction_${this.noteableType.toLowerCase()}`;
        }
    },
    created () {
        if (window.mrTabs) {
            const { eventHub, currentTab } = window.mrTabs;
            eventHub.$on('MergeRequestTabChange', this.toggleFilters);
            this.toggleFilters(currentTab);
        }
        notesEventHub.$on('dropdown-select', this.selectFilter);
        window.addEventListener('hashchange', this.handleLocationHash);
    },
    mounted () {
        this.toggleCommentsForm();
    },
    destroyed () {
        notesEventHub.$off('dropdown-select', this.selectFilter);
        window.removeEventListener('hashchange', this.handleLocationHash);
    },
    methods: {
        ...mapActions(useNotes, [
            'filterDiscussion',
            'setCommentsDisabled',
            'setTargetNoteHash',
            'setTimelineView',
            'setDiscussionSortDirection'
        ]),
        selectFilter (value, persistFilter = true) {
            const filter = parseInt(value, 10);
            if (filter === this.currentValue) return;
            if (this.timelineEnabled && filter !== COMMENTS_ONLY_FILTER_VALUE) {
                this.setTimelineView(false);
            }
            this.currentValue = filter;
            this.filterDiscussion({
                path: this.getNotesDataByProp('discussionsPath'),
                filter,
                persistFilter
            });
            this.toggleCommentsForm();
        },
        toggleCommentsForm () {
            this.setCommentsDisabled(this.currentValue === HISTORY_ONLY_FILTER_VALUE);
        },
        toggleFilters (tab) {
            this.displayFilters = tab === DISCUSSION_TAB_LABEL;
        },
        handleLocationHash () {
            const hash = getLocationHash();
            if (/^note_/.test(hash) && this.currentValue !== DISCUSSION_FILTERS_DEFAULT_VALUE) {
                this.selectFilter(this.defaultValue, false);
                this.setTargetNoteHash(hash);
            }
        },
        filterType (value) {
            if (value === 0) {
                return DISCUSSION_FILTER_TYPES.ALL;
            }
            if (value === 1) {
                return DISCUSSION_FILTER_TYPES.COMMENTS;
            }
            return DISCUSSION_FILTER_TYPES.HISTORY;
        },
        fetchSortedDiscussions (direction) {
            if (this.isSortDropdownItemActive(direction)) {
                return;
            }
            this.setDiscussionSortDirection({
                direction
            });
            this.track('change_discussion_sort_direction', {
                property: direction
            });
        },
        isSortDropdownItemActive (sortDir) {
            return sortDir === this.sortDirection;
        }
    }
};
